import { useState } from 'react';

export const useModalControls = () => {
  const [more, setMore] = useState(false);
  const [terms, setTerms] = useState(false);
  const [privatePolicy, setPrivatePolicy] = useState(false);
  const [openModelMoreDetails, setOpenModelMoreDetails] = useState(false);

  const onClickMoreOptions = () => {
    setMore((old) => !old);
  };

  return {
    more,
    setMore,
    onClickMoreOptions,
    terms,
    setTerms,
    privatePolicy,
    setPrivatePolicy,
    openModelMoreDetails,
    setOpenModelMoreDetails,
  };
};
